import { render, staticRenderFns } from "./Neptune.vue?vue&type=template&id=5c65ce1c&"
import script from "./Neptune.vue?vue&type=script&lang=js&"
export * from "./Neptune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports